import React from 'react';
import { connect } from 'react-redux';
import styles from './Common.module.css'
import { PatientCareCenterNoteChargesGroupRow } from './GroupRow';

class PatientCareCenterNoteChargesGroupSection extends React.Component {

    render() {
        if (this.props.activities.length > 0) {
            return (
                <div>
                    <div className={styles.row}>
                        <span className={styles.col1} >
                            <b>{this.props.name}</b>
                        </span>
                        <span className={styles.col2}>
                            <div className={styles.int_field}>
                            </div>
                        </span>
                    </div>

                    {Object.keys(this.props.activities)
                        .map(key => {
                            const act = this.props.activities[key];
                            return (
                                <PatientCareCenterNoteChargesGroupRow
                                    key={act.id}
                                    id={act.id}
                                    table={this.props.table}
                                    prefix={this.props.prefix}
                                    noteId={this.props.noteId}
                                    activity={act.activity}
                                    selected={act.selected}
                                />
                            )
                        })
                    }

                </div>
            );
        } else {
            return (<span />);
        }
    }

}

function mapStateToProps(state, ownprops) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let xlno = parseInt(Object.keys(state.entities.notes.MLEXLOG)
        .find(key => (state.entities.notes.MLEXLOG[key].XLEVNO === pk && noteType === 1)
            || (state.entities.notes.MLEXLOG[key].XLNTNO === pk && noteType !== 1)));

    let activities = state.entities.notes[ownprops.table] ?
        Object.keys(state.entities.notes[ownprops.table])
            .filter(key => {
                return (state.entities.notes[ownprops.table][key][ownprops.prefix + 'XLNO'] === xlno &&
                    state.entities.notes[ownprops.table][key][ownprops.prefix + 'PERFORMED'] === true)
            })
            .sort((a, b) => state.entities.notes[ownprops.table][a][ownprops.prefix + 'NO'] - state.entities.notes[ownprops.table][b][ownprops.prefix + 'NO'])
            .map(key => {
                let act = state.entities.notes[ownprops.table][key][ownprops.prefix + ownprops.masterPrefix + 'NO'] ?
                    state.entities.masterData[ownprops.masterTable][state.entities.notes[ownprops.table][key][ownprops.prefix + ownprops.masterPrefix + 'NO']][ownprops.masterPrefix + 'NAME'] : '<Activity Not Defined>';
                act += state.entities.notes[ownprops.table][key][ownprops.prefix + 'ACTIVITY'] ? ' - ' + state.entities.notes[ownprops.table][key][ownprops.prefix + 'ACTIVITY'] : '';
                return {
                    activity: act,
                    id: state.entities.notes[ownprops.table][key][ownprops.prefix + 'NO'],
                    selected: state.entities.notes[ownprops.table][key][ownprops.prefix + 'ISGROUP']
                };
            }) : [];

    return {
        noteId,
        noteType,
        xlno,
        activities
    };
}

const connectedPatientCareCenterNoteChargesGroupSection = connect(mapStateToProps)(PatientCareCenterNoteChargesGroupSection);
export { connectedPatientCareCenterNoteChargesGroupSection as PatientCareCenterNoteChargesGroupSection };

